export default "__VITE_ASSET__b390e9f2__"